/**
 * src/components/auth/RequireAuth.tsx
 * =============================================================================
 * Guard para rutas que requieren sesión. Si no hay usuario, redirige a /login
 * conservando la ruta de origen para volver después del login.
 *
 * Mientras AuthProvider está en loading=true (comprobando sesión persistida)
 * muestra un splash neutro — evita el "flash" de la login screen cuando el
 * usuario en realidad sí tiene sesión.
 * =============================================================================
 */

import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/components/providers/AuthProvider'
import { FullPageLoader } from '@/components/ui/FullPageLoader'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth()
  const location = useLocation()

  if (loading) return <FullPageLoader />
  if (!session) return <Navigate to="/login" replace state={{ from: location }} />

  return <>{children}</>
}
